import axiosClient from "../apiClient.js";

const baseEndpoint = "/message";

export const messageObject = {
  userName: "",
  isSingle: true,
  templateId: 0,
  memberId: 0,
  description: "",
};

export const getMessageTemplateById = (id) => {
  return axiosClient.get(`${baseEndpoint}/getmessagetemplatebyid?id=${id}`);
};

export const send = (data) => {
  return axiosClient.post(`${baseEndpoint}/send`, JSON.stringify(data));
};
